import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Container } from "@material-ui/core";
import Menu from "./HeaderComponents/Menu";
import Logo from "./HeaderComponents/Logo";
import Profil from "./HeaderComponents/Profil";
import Humberbar from "./HeaderComponents/Humberbar";

const Header = function Header() {
  const classes = useStyles();
  return (
    <div className={classes.container} id="header">
      <Container maxWidth="lg" className={classes.content}>
        <Humberbar />
        <Logo />
        <Menu />
        <Profil />
      </Container>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    backgroundColor: "#fff",
    position: "relative",
    zIndex: 1,
  },
  content: {
    display: "flex",
    alignItems: "center",
    height: 70,
  },
});

export default Header;
